import { Icon } from '@iconify/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContactInfoWidget() {
  const { t } = useTranslation();
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        {t('footer.contact.addressLine1')}<br/>
        {t('footer.contact.addressLine2')}
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        {t('footer.contact.phone')}
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        {t('footer.contact.email')}
      </li>
    </ul>
  );
}
